module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Bold-f2dcaf0c9fa1ec001679d129cc98ba7a.ttf";